import {
    Button,
    Modal,
    ModalActions,
    ModalContent,
    ModalHeader,
    Toggle,
} from '@/platform/ui';
import { Link, usePage } from '@inertiajs/react';
import qs from 'qs';
import { useState } from 'react';

const ExportModal = () => {
    const { filters, auth } = usePage().props;

    const [isOpen, setIsOpen] = useState(false);
    const [bsnIncluded, setBsnIncluded] = useState(false);

    if (!isOpen) {
        return <Button onClick={() => setIsOpen(true)}>Exporteren SROI</Button>;
    }

    return (
        <Modal open={isOpen} onClose={() => setIsOpen(false)}>
            <ModalHeader>SROI overzicht exporteren</ModalHeader>
            <ModalContent>
                <Toggle
                    label='BSN opnemen'
                    checked={bsnIncluded}
                    onChange={() => setBsnIncluded(!bsnIncluded)}
                />
            </ModalContent>
            <ModalActions>
                <Button onClick={() => setIsOpen(false)} type='button'>
                    Annuleren
                </Button>
                <Button
                    variant='primary'
                    as={Link}
                    target='_blank'
                    rel='noopener noreferrer'
                    href={`/customers/${auth?.user?.selected_customer_id}/services/sroi/export?${qs.stringify(
                        {
                            format: 'excel',
                            year: filters?.year,
                            entity_ids: filters?.entity_ids,
                            include_bsn: bsnIncluded ? 1 : 0,
                        }
                    )}`}
                >
                    Exporteren Excel
                </Button>
                <Button
                    variant='primary'
                    as={Link}
                    target='_blank'
                    rel='noopener noreferrer'
                    href={`/customers/${auth?.user?.selected_customer_id}/services/sroi/export?${qs.stringify(
                        {
                            format: 'pdf',
                            year: filters?.year,
                            entity_ids: filters?.entity_ids,
                            include_bsn: bsnIncluded ? 1 : 0,
                        }
                    )}`}
                >
                    Downloaden PDF
                </Button>
            </ModalActions>
        </Modal>
    );
};

export default ExportModal;
